import React from "react";
import useFetch from "starkeydigital/React/Hooks/useFetch";
import {TeamMember} from "../@types/teamMembers";
import Row from "starkeydigital/React/Components/row";
import Column from "starkeydigital/React/Components/column";
import {Carousel} from "react-responsive-carousel";
import HeaderDivideTextLeft from "./headerDivideTextLeft";
import {PulseLoader} from "react-spinners";
import styled from "@emotion/styled";
import {StaticImage} from "gatsby-plugin-image";
import Container from "starkeydigital/React/Components/container";
import SimpleCarousel from "starkeydigital/React/Components/simpleTestimonialCarousel";
import Link from "./link";
import HeaderDivideText from "./headerDivideText";
import AnimateUp from "starkeydigital/React/Components/AnimateUp";

interface props {}
interface Data {
  data: TeamMember[];
}

const TeamMembers: React.FC<props> = (props) => {
  const [selected, setSelected] = React.useState<number>(0);

  const {data, loading, error} = useFetch<Data>(
    "https://cms.starkeydigital.com/items/atd_team_member?fields=*.*",
  );

  const Text = styled.div`
    font-family: Poppins;
    font-style: italic;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;

    text-align: center;
    letter-spacing: 0.025em;

    color: #02578c;
  `;

  if (loading)
    return (
      <Row justify="center">
        <PulseLoader />
      </Row>
    );

  if (error) return <></>;

  return (
    <>
      <Row style={{marginTop: "135px"}}>
        <Column>
          <HeaderDivideText
            column="col-md-8"
            header="Meet the Team"
            text="Alison leads a team of highly qualified, expert coaches with wide ranging international experience.
Our coaches work at board level and with business teams and individuals.
Discover more about the team below."
          />
        </Column>
      </Row>
      <Row>
        <Column>
          <AnimateUp>
            <Carousel
              autoPlay={true}
              showStatus={false}
              showThumbs={false}
              showIndicators={false}
              infiniteLoop={true}
              emulateTouch={true}
              selectedItem={selected}
              axis="horizontal"
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && (
                  <div
                    onClick={onClickHandler}
                    style={{
                      position: "absolute",
                      left: "0px",
                      bottom: "0px",
                      cursor: "pointer",
                      zIndex: 1000,
                    }}
                  >
                    <StaticImage
                      src="../images/left-arrow.png"
                      alt="left arrow"
                    />
                  </div>
                )
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && (
                  <div
                    onClick={onClickHandler}
                    style={{
                      position: "absolute",
                      right: "0",
                      bottom: "0",
                      cursor: "pointer",
                      zIndex: 1000,
                    }}
                  >
                    <StaticImage
                      src="../images/arrow-right.png"
                      alt="left arrow"
                    />
                  </div>
                )
              }
            >
              {data?.data.map((member, index) => (
                <Row key={index}>
                  <Column class="col-md-5">
                    <MemberCard member={member} />
                  </Column>
                  <Column class="col-md-1" />

                  <Column class="col-md-6 d-md-block d-none">
                    <SimpleCarousel
                      leftArrow={
                        <StaticImage
                          src="../images/right.png"
                          alt="right arrow"
                        />
                      }
                      rightArrow={
                        <StaticImage
                          src="../images/left.png"
                          alt="left arrow"
                        />
                      }
                    >
                      {member.atd_team_member_endorsment.map(
                        (endorsment, index) => (
                          <div style={{textAlign: "left"}}>
                            <StaticImage
                              src="../images/quote-top.png"
                              alt="quote"
                            />

                            <Text
                              key={index}
                              dangerouslySetInnerHTML={{
                                __html: endorsment.endorsment,
                              }}
                            />
                            <div className="row justify-content-end">
                              <StaticImage
                                src="../images/quote-bottom.png"
                                alt="quote"
                                style={{marginRight: "15px"}}
                              />
                            </div>
                          </div>
                        ),
                      )}
                    </SimpleCarousel>
                  </Column>
                </Row>
              ))}
            </Carousel>
          </AnimateUp>
        </Column>
      </Row>
      {/* <Row class="desktop-only">
        <Column>
        <Members>
        {data?.data.map((user, index) => (
            <div
            className="flex flex-column justify-content-center align-items-center"
                onClick={() => setSelected(index)}
              >
                <Image src={`${imageUrl}${user.image.id}`} alt="image" />
                <p>{user.name}</p>
              </div>
            ))}
          </Members>
        </Column>
      </Row> */}
    </>
  );
};

const Image = styled.img`
  width: 161px !important;
  height: 162px !important;
  cursor: pointer;
`;

const imageUrl = "https://cms.starkeydigital.com/assets/";

export default TeamMembers;

interface MemberCardProps {
  member: TeamMember;
}

const Members = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

const MemberCard: React.FC<MemberCardProps> = (props) => {
  const imageUrl =
    "https://cms.starkeydigital.com/assets/" + props.member.image.id;

  let cleanText = props.member.description
    .toString()
    .replace(/<\/?[^>]+(>|$)/g, "");

  const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    max-width: 471px;
    height: 471px;
    background: #ffffff;
    border-radius: 30px;
    top: 20px;
    left: 20px;

    @media (max-width: 768px) {
      left: 0;
    }
  `;

  const ContainerBackground = styled.div`
    position: absolute;
    right: 20px;
    height: 423px;
    background: rgba(106, 178, 226, 0.1);
    border-radius: 30px;
    z-index: -1;
    top: -20px;
    left: -20px;
    @media (max-width: 768px) {
      left: 0;
    }
  `;

  const TextBox = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    text-align: center;
    letter-spacing: 0.025em;
    color: #02578c;
    padding: 0 1rem;
  `;

  const Image = styled.img`
    width: 161px !important;
    height: 162px !important;
  `;

  const LinkStyle = styled.div`
    font-family: Averta CY;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 45px;
    /* identical to box height, or 250% */

    letter-spacing: -0.025em;

    cursor: pointer;
    color: #02578c;
  `;

  const url = `/coaches/${props.member.id}`;
  return (
    <Container>
      <Image src={imageUrl} alt="main-image" />
      <ContainerBackground />

      <p>
        <strong>{props.member.name}</strong>
      </p>

      <TextBox
        dangerouslySetInnerHTML={{
          __html: cleanText,
        }}
      />
      {/* {props.member.description} */}

      <Link to={url}>
        <LinkStyle>Read More</LinkStyle>
      </Link>
    </Container>
  );
};
